
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { isAuthenticated, isSuperAdmin, logoutUser } from '@/utils/auth';
import { safeUserRole } from '@/utils/roleUtils';
import { getCurrentUser } from '@/utils/auth/authService';
import { SaasInstance } from '@/types/userRole';
import SuperAdminLayout from '@/components/superadmin/SuperAdminLayout';
import PaymentsManagement from '@/components/admin/PaymentsManagement';

const SuperAdminInstancePayments: React.FC = () => {
  const { id: instanceId } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [instance, setInstance] = useState<SaasInstance | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      const currentUser = getCurrentUser();
      const userRole = safeUserRole(currentUser?.role);
      
      if (!isAuthenticated() || !isSuperAdmin(userRole)) {
        navigate('/login');
        return;
      }
      
      const mockInstance: SaasInstance = {
        id: instanceId || 'unknown',
        name: 'Test Instance',
        domain: 'test.example.com',
        subdomain: 'test',
        status: 'active' as 'active',
        plan: 'premium' as 'premium',
        ownerId: 'owner-1',
        createdAt: new Date().toISOString(), // Convert Date to string
        customization: {
          primaryColor: '#4A80F0',
          logo: '/logo.png'
        },
        settings: {
          logoUrl: '/logo.png',
          primaryColor: '#4A80F0'
        }
      };
      
      setInstance(mockInstance);
      setIsLoading(false);
    };
    
    checkAuth();
  }, [instanceId, navigate]);

  const handleLogout = async () => {
    try {
      await logoutUser();
      navigate('/login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <SuperAdminLayout
      isLoading={isLoading || !instance}
      onLogout={handleLogout}
      userRole="superadmin"
      activeTab="instances"
    >
      <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
        <h1 className="text-2xl font-bold mb-6">Payment Settings - {instance?.name}</h1>
        
        <PaymentsManagement instanceId={instance?.id || ''} />
      </div>
    </SuperAdminLayout>
  );
};

export default SuperAdminInstancePayments;
